export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14259.6138c223.jpg";